import { useState, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { Html5Qrcode } from "html5-qrcode";
import "bootstrap/dist/css/bootstrap.min.css";
import CustomNav from "../components/CustomNav";
import Footer from "../components/Footer";
import NewNav from "../components/NewNav";

const Support = () => {
  const [scanActive, setScanActive] = useState(false);
  const [productInfo, setProductInfo] = useState(null);
  let scanner;

  useEffect(() => {
    if (scanActive) {
      scanner = new Html5Qrcode("qr-reader");

      scanner.start(
        { facingMode: "environment" }, // Back Camera Default
        { fps: 10, qrbox: 250 },
        (decodedText) => {
          handleScan(decodedText);
        },
        (error) => console.log("QR Code scan error:", error)
      );

      return () => scanner.stop();
    }
  }, [scanActive]);

  const handleScan = (decodedText) => {
    // Dummy data for product authenticity and warranty status
    const productData = {
      "QH12345": { authenticity: "Authentic", warranty: "Available" },
      "QH67890": { authenticity: "Authentic", warranty: "Not Available" },
    };

    const product = productData[decodedText] || { authenticity: "Unknown", warranty: "N/A" };
    setProductInfo(product);
    setScanActive(false);
  };

  return (
    <>
 <NewNav/>
      <div className="support-wrapper text-center d-flex justify-content-center align-items-center" style={{ padding: "20px" }}>
        <Card className="support-card w-100" style={{ maxWidth: "500px" }}>
          <Card.Body>
            <h3>Scan Product QR CODE</h3>
            {!scanActive ? (
              <Button className="scan-btn w-100" onClick={() => setScanActive(true)}>
                Start Camera
              </Button>
            ) : (
              <>
                <div id="qr-reader" style={{
                  width: "100%",
                  maxWidth: "100%",
                  height: "auto",
                  aspectRatio: "16 / 9"
                }}></div>
                <Button className="scan-btn w-100 mt-3" onClick={() => setScanActive(false)}>
                  Stop Camera
                </Button>
              </>
            )}
            {productInfo && (
              <div className="product-info mt-3">
                <h5>Product Authenticity: {productInfo.authenticity}</h5>
                <h6>Warranty Claim: {productInfo.warranty}</h6>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
      <Footer />
    </>
  );
};

export default Support;
